import { api } from './client';
import type { VerdictListResponse } from './types';

export function getVerdicts(params: {
  page: number;
  limit?: number;
  evaluator?: string;
  confidence?: string;
  framework?: string;
}) {
  const qs = new URLSearchParams({ page: String(params.page) });
  if (params.limit) qs.set('limit', String(params.limit));
  if (params.evaluator) qs.set('evaluated_by', params.evaluator);
  if (params.confidence) qs.set('confidence', params.confidence);
  if (params.framework) qs.set('framework', params.framework);
  return api.get<VerdictListResponse>(`/api/admin/verdicts?${qs}`);
}
